// Add Up Redux Slices Here
// create redux slice function as reducer

// Every Page has their own redux slice function
import { createSlice } from '@reduxjs/toolkit';
import orderService from 'service/order';
import { trackJourney } from 'telemetry/journey';

// import { notification } from 'antd';
// import history from 'utils/history';
// TODO -> Handle api errors

export const orderSlice = createSlice({
  name: 'order',
  initialState: {
    orders: [],
    loading: false,
    loadingMore: false,
    hasMore: false
  },
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload;
    },

    appendOrders: (state, action) => {
      state.orders = state.orders.concat(action.payload);
    },

    // Loading handler
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setLoadingMore: (state, action) => {
      state.loadingMore = action.payload;
    },

    setHasMore: (state, action) => {
      state.hasMore = action.payload;
    }
  }
});

export const { setOrders, appendOrders, setLoading, setLoadingMore, setHasMore } =
  orderSlice.actions;

export const getOrders =
  (query = '', journey = false, { append = false, limit } = {}) =>
  async (dispatch, getState) => {
    if (append) dispatch(setLoadingMore(true));
    else dispatch(setLoading(true));
    if (journey) trackJourney('order-history', { outcome: 'attempted' });
    const data = await orderService.getOrders(query);
    if (journey) trackJourney('order-history', {
      outcome: !data ? 'failed' : Array.isArray(data) && data.length === 0 ? 'empty' : 'loaded',
      failureCode: data ? 'none' : 'order_api_failed'
    });

    const pageIsFull =
      Array.isArray(data) && Number.isFinite(limit) && data.length >= limit;
    let hasMore = false;

    if (append && Array.isArray(data)) {
      const seen = new Set(
        (getState().order.orders || []).map((order) => order?.id)
      );
      const fresh = data.filter((order) => order?.id && !seen.has(order.id));
      if (fresh.length) dispatch(appendOrders(fresh));
      hasMore = pageIsFull && fresh.length > 0;
    } else if (Array.isArray(data)) {
      dispatch(setOrders(data));
      hasMore = pageIsFull;
    }

    dispatch(setHasMore(hasMore));
    dispatch(setLoading(false));
    dispatch(setLoadingMore(false));
    return { ok: Array.isArray(data), hasMore };
  };

export default orderSlice.reducer;
